import { all } from 'redux-saga/effects';
import { watchRestaurantSaga } from './restaurantSaga';
import { watchMenuItemsSaga } from './menuItemsSaga';
import { watchMenuItemDetailsSaga } from './menuItemDetailsSaga';
import { watchTpnConfigSaga } from './tpnConfigSaga';
import { watchImageUploadSaga } from './imageUploadSaga';
import { watchSiteContentSaga } from './siteContentSaga';
import { watchOrderSaga } from './orderSaga';
import { watchTableAvailabilitySaga } from './tableAvailabilitySaga';
import { watchMakeReservationSaga } from './makeReservationSaga';
import { categoriesSaga } from './categoriesSaga';
import { modifiersSaga } from './modifiersSaga';

export default function* rootSaga() {
  yield all([
    watchRestaurantSaga(), 
    watchMenuItemsSaga(), // NEW API - Menu items list
    watchMenuItemDetailsSaga(), // NEW API - Menu item details
    watchTpnConfigSaga(), 
    watchImageUploadSaga(),
    watchSiteContentSaga(),
    watchOrderSaga(),
    watchTableAvailabilitySaga(),
    watchMakeReservationSaga(),
    categoriesSaga(),
    modifiersSaga(),
  ]);
}
